import React, { useEffect, useMemo, useState } from "react";
import { MenuModifier, MenuModifiersGroup } from "../../../@types/stores/menu";
import { useTranslation } from "react-i18next";
import lodash from "lodash";
import { ReactComponent as IconCheck } from "../../../assets/icons/check.svg";
import { getHost } from "../../../helpers/ApiHelper";


export interface ModifiersGroupProps {
    modifiersGroup: MenuModifiersGroup;
    onChange: (modifiersGroupId: number, selectedModifiers: number[]) => void;
    selected: number[];
}

const ModifiersGroup = ({ modifiersGroup, onChange, selected }: ModifiersGroupProps) => {
    const [t] = useTranslation();

    const [modifiers, setModifier] = useState<number[]>([]);

    useEffect(() => {
        if (!lodash.isEqual(selected, modifiers))
            setModifier(selected);
    }, [selected]);

    const hasImage = useMemo(() => {
        for (const a of modifiersGroup.items) {
            if (a.previewList)
                return true;
        }
        return false;
    }, [modifiersGroup]);

    const changeModifier = (id: number, min: number, max: number) => {
        if (max === 1) {
            setModifier([id]);
            onChange(modifiersGroup.id, [id]);
        }
        else {
            let newModifiers = lodash.cloneDeep(modifiers);
            if (newModifiers.some(x => x === id))
                newModifiers = newModifiers.filter(x => x !== id);
            else {
                if (newModifiers.length < max)
                    newModifiers.push(id);
            }
            setModifier(newModifiers);
            onChange(modifiersGroup.id, newModifiers);
        }
    }

    return <div className="ModifiersGroup">
        <div className="text">
            {modifiersGroup.name} <span className="min-max">{t("min")}: {modifiersGroup.min || 0}, {t("max")}: {modifiersGroup.max || 100}</span>
        </div>
        <div>
            <div className="blocks">
                {modifiersGroup.items.map((m: MenuModifier) =>
                    <div key={`modifierGroup_${modifiersGroup.name}_mogifier_${m.id}`} className={`block ${modifiers.some(x => x === m.id) ? "active" : ""}`} onClick={() => changeModifier(m.id, modifiersGroup.min || 0, modifiersGroup.max || 100)}>
                        {modifiers.some(x => x === m.id)
                            ? <IconCheck className="check" />
                            : null
                        }
                        {hasImage
                            ? <div className="img">
                                {m.previewList
                                    ? <img alt={m.name} src={`${getHost()}${m.previewList}`} />
                                    : null
                                }
                            </div>
                            : null
                        }
                        <div className="text">
                            <div className="title">
                                {m.name}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    </div>
}

export default ModifiersGroup;
